var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollaborating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 250,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with ImageTracer.java version 1.1.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    desc: "l 1 p 0",
    fill: "rgb(254,254,254)",
    stroke: "rgb(254,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 0.5 0.0 L 238.0 0.5 L 237.5 250.0 L 0.0 249.5 L 0.5 0.0 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 0",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 38.0 L 188.5 40.0 L 189.5 38.0 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 0",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 39.0 L 189.0 40.5 L 187.5 40.0 L 186.5 39.0 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 0",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 185.5 40.0 L 181.5 45.0 L 185.5 40.0 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 0",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 186.5 40.0 L 203.0 55.5 L 197.5 63.0 Q 195.3 63.8 196.0 67.5 Q 197.3 72.3 195.0 73.5 L 192.0 81.5 L 185.0 88.5 L 164.5 109.0 L 162.0 107.5 Q 161.3 102.8 164.5 102.0 L 173.0 93.5 L 176.5 90.0 Q 178.8 89.3 178.0 85.5 L 175.5 85.0 L 152.5 107.0 Q 148.3 105.3 151.0 103.5 L 163.5 90.0 L 166.5 87.0 L 168.0 83.5 L 165.5 82.0 L 150.0 97.5 L 146.0 101.5 Q 145.3 103.8 141.5 103.0 L 141.0 99.5 L 155.0 85.5 Q 160.3 83.3 161.0 76.5 L 158.5 76.0 L 146.0 88.5 L 143.0 91.5 Q 142.3 93.8 138.5 93.0 L 138.0 89.5 L 150.5 76.0 L 152.0 75.5 L 160.0 66.5 Q 163.5 66.0 163.0 61.5 L 160.5 61.0 L 151.0 70.5 L 144.5 75.0 Q 142.3 74.3 143.0 70.5 L 157.0 56.5 Q 160.2 50.2 168.5 49.0 L 173.5 48.0 Q 179.3 49.3 180.5 46.0 L 186.5 40.0 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 1",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 41.0 L 42.5 49.0 L 49.5 41.0 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 2",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 51.5 41.0 L 54.5 45.0 L 51.5 41.0 Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 1",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 189.5 41.0 L 202.5 55.0 L 189.5 41.0 Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 1",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 49.5 42.0 L 52.5 43.0 L 56.0 46.5 Q 56.8 49.8 61.5 49.0 L 68.0 49.5 Q 76.4 50.6 80.0 56.5 L 97.0 72.5 L 94.5 76.0 L 86.5 70.0 L 76.5 61.0 Q 72.7 65.7 65.5 67.0 L 58.5 64.0 L 57.0 66.5 Q 59.6 71.9 68.5 71.0 L 76.5 66.0 L 81.5 72.0 Q 76.0 70.5 74.5 73.0 L 68.0 77.5 Q 65.0 80.5 66.0 87.5 L 65.5 102.0 L 47.0 84.5 Q 41.5 79.0 42.0 67.5 L 45.0 58.5 L 42.5 57.0 L 38.5 63.0 L 35.0 60.5 L 36.0 56.5 L 39.0 53.5 L 49.5 42.0 Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 1",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 178.5 42.0 L 179.5 44.0 L 178.5 42.0 Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 2",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 191.5 42.0 L 203.5 55.0 L 191.5 42.0 Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 3",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 43.5 45.0 L 42.5 47.0 L 43.5 45.0 Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 2",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 55.5 45.0 L 58.5 49.0 L 55.5 45.0 Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 4",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 45.0 L 59.0 45.5 Q 56.9 48.8 56.5 45.0 Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 3",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 180.5 45.0 L 179.5 47.0 L 180.5 45.0 Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 5",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 173.5 46.0 L 178.0 46.5 L 173.5 47.0 L 173.5 46.0 Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 3",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 47.0 L 179.0 47.5 L 171.5 48.0 L 171.5 47.0 Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 4",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 48.0 L 67.0 48.5 L 59.5 49.0 L 59.5 48.0 Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 6",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 49.0 L 35.5 56.0 L 41.5 49.0 Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 4",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 49.0 L 35.5 57.0 L 42.5 49.0 Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 7",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 49.0 L 162.5 51.0 L 161.5 49.0 Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 8",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 50.0 L 76.0 51.5 L 74.5 51.0 L 73.5 50.0 Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 5",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 50.0 L 162.5 52.0 L 163.5 50.0 Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 5",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 51.0 L 143.5 70.0 L 161.5 51.0 Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 6",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 52.0 L 77.5 54.0 L 76.5 52.0 Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 6",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 54.0 L 84.5 61.0 L 78.5 54.0 Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 9",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 55.0 L 83.5 58.0 L 85.5 58.0 L 87.0 57.5 L 86.5 59.0 L 87.5 61.0 L 84.0 59.5 L 80.5 55.0 Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 7",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 57.0 L 199.5 61.0 L 202.5 57.0 Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 10",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 203.5 57.0 L 202.0 59.5 L 201.5 61.0 L 201.0 59.5 L 203.5 57.0 Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 11",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 42.5 58.0 L 41.5 60.0 L 42.5 58.0 Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 8",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 44.5 58.0 L 45.0 60.5 L 44.0 60.5 L 44.5 58.0 Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 7",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 200.5 60.0 L 197.0 64.5 L 196.5 73.0 L 196.0 64.5 L 200.5 60.0 Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 12",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 35.5 61.0 L 40.0 64.5 L 37.5 65.0 L 35.5 61.0 Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 9",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 36.5 61.0 Q 38.3 64.1 40.0 62.5 L 38.0 63.5 L 36.5 61.0 Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 10",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 61.0 L 83.0 66.5 L 77.5 62.0 L 76.5 61.0 Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 8",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 61.0 L 94.5 70.0 L 86.5 61.0 Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 9",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 160.5 61.0 L 147.5 75.0 L 160.5 61.0 Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 13",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 61.0 L 162.5 63.0 L 161.5 61.0 Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 11",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 62.0 L 72.5 65.0 L 74.5 62.0 Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 10",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 62.0 L 74.5 64.0 L 75.5 62.0 Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 14",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 62.0 L 81.5 67.0 L 78.5 64.0 L 76.5 64.0 L 75.0 64.5 L 77.5 62.0 Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 11",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 63.0 L 154.5 72.0 L 162.5 63.0 Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 12",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 58.5 64.0 L 61.0 65.5 L 59.5 65.0 L 58.0 65.5 L 60.0 68.5 L 57.0 66.5 L 58.5 64.0 Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 13",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 76.5 65.0 L 75.5 67.0 L 76.5 65.0 Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 15",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 65.0 L 157.5 67.0 L 158.5 65.0 Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 16",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 66.0 L 62.0 67.5 L 60.0 68.5 L 61.5 66.0 Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 12",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 66.0 L 69.0 66.5 L 66.5 67.0 L 66.5 66.0 Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 13",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 66.0 L 83.0 72.5 L 75.5 73.0 L 75.5 72.0 L 82.0 71.5 L 77.5 66.0 Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 17",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 67.0 L 68.0 67.5 L 64.5 68.0 L 64.5 67.0 Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 18",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 79.5 67.0 L 84.5 73.0 L 79.5 67.0 Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 14",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 67.0 L 90.5 75.0 L 83.5 67.0 Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 15",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 41.5 68.0 L 42.0 72.5 L 41.0 72.5 L 41.5 68.0 Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 19",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 68.0 Q 99.5 69.5 96.5 71.0 Q 93.5 69.5 96.5 68.0 Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 20",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 68.0 L 154.5 70.0 L 155.5 68.0 Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 16",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 71.0 L 144.0 74.5 L 142.0 73.5 L 142.5 71.0 Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 21",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 72.0 L 154.0 72.5 L 137.0 88.5 Q 140.1 86.8 138.5 85.0 Q 139.8 87.3 141.0 84.5 L 147.0 78.5 L 146.5 77.0 L 148.0 77.5 L 151.0 74.5 Q 148.8 73.3 151.5 72.0 Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 22",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 74.0 L 81.5 75.0 L 88.0 75.5 L 76.5 76.0 L 77.5 74.0 Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 14",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 74.0 L 92.5 76.0 L 91.5 74.0 Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 15",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 74.0 L 95.5 76.0 L 96.5 74.0 Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 23",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 74.0 L 125.5 75.0 L 134.5 75.0 Q 140.5 73.5 142.0 76.5 L 140.5 76.0 L 121.0 76.5 L 120.5 89.0 L 120.0 76.5 L 122.5 74.0 Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 17",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 75.0 L 69.5 77.0 L 70.5 75.0 Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 24",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 75.0 L 92.5 77.0 L 91.5 75.0 Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 25",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 75.0 L 97.5 77.0 L 95.0 76.5 L 96.5 75.0 Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 26",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 75.0 L 118.0 75.5 L 99.5 76.0 L 99.5 75.0 Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 27",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 144.5 75.0 L 148.0 75.5 L 144.5 76.0 L 144.5 75.0 Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 28",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 76.0 L 71.5 79.0 L 69.5 78.0 L 68.0 78.5 L 70.5 77.0 Q 72.0 79.5 73.5 76.0 Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 2",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 76.0 L 84.5 76.0 Q 88.3 75.3 89.0 77.5 Q 90.4 80.6 95.5 80.0 L 99.0 77.5 Q 100.0 75.0 104.5 76.0 L 116.5 76.0 L 117.5 92.0 L 121.5 93.0 L 123.5 93.0 Q 128.6 92.4 130.0 95.5 L 131.0 102.5 L 128.0 105.5 Q 127.0 108.0 122.5 107.0 Q 118.0 106.0 117.0 108.5 L 116.5 123.0 L 105.0 122.5 Q 106.4 112.1 99.5 110.0 L 90.5 109.0 L 85.0 112.5 Q 81.2 115.7 81.5 123.0 L 70.0 122.5 L 70.0 93.5 Q 68.0 81.0 74.5 77.0 L 77.5 76.0 Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 18",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 76.0 L 89.5 78.0 L 88.5 76.0 Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 19",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 76.0 L 118.0 90.5 L 117.0 90.5 L 117.5 76.0 Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 3",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 76.0 L 131.5 76.0 L 137.5 77.0 L 139.5 77.0 L 143.0 78.5 L 136.5 85.0 L 134.0 88.5 L 133.0 91.5 L 138.0 97.5 Q 135.8 98.8 137.0 103.5 L 143.5 108.0 L 146.5 107.0 Q 147.5 112.0 154.5 111.0 L 158.5 109.0 L 160.5 112.0 L 165.5 113.0 L 167.5 112.0 L 168.0 122.5 L 157.5 123.0 Q 153.0 122.0 152.0 124.5 Q 153.1 134.1 147.5 137.0 Q 139.5 138.5 138.0 133.5 L 137.0 128.5 Q 138.0 124.0 135.5 123.0 L 121.0 122.5 L 121.5 111.0 Q 131.9 112.4 134.0 105.5 L 135.0 96.5 L 130.5 90.0 L 121.0 87.5 L 122.0 83.5 L 121.0 81.5 L 122.0 78.5 Q 119.8 77.3 122.5 76.0 Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 20",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 158.5 76.0 L 161.0 77.5 L 160.5 79.0 L 159.5 77.0 L 149.5 86.0 L 158.5 76.0 Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 16",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 77.0 L 71.5 80.0 L 73.5 77.0 Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 21",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 77.0 L 143.5 79.0 L 140.5 82.0 L 141.5 80.0 L 142.5 77.0 Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 17",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 77.0 L 138.5 89.0 L 149.5 77.0 Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 18",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 78.0 L 122.0 80.5 L 121.0 80.5 L 121.5 78.0 Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 29",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 79.0 L 143.5 96.0 L 151.0 87.5 Q 155.3 85.3 153.5 83.0 Q 155.3 85.8 157.0 81.5 L 156.5 80.0 Q 158.0 82.5 159.5 79.0 Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 19",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 80.0 L 141.5 99.0 L 159.5 80.0 Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 20",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 66.5 81.0 L 67.0 102.5 L 65.5 103.0 L 56.5 93.0 L 66.0 101.5 L 66.5 81.0 Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 22",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 192.5 81.0 L 177.5 97.0 L 192.5 81.0 Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 21",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 82.0 L 46.5 84.0 L 45.5 82.0 Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 30",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 69.5 82.0 L 70.0 119.5 L 69.0 119.5 L 68.5 102.0 L 67.0 102.5 Q 70.3 101.3 69.0 95.5 L 69.5 82.0 Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 22",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 139.5 82.0 L 134.5 88.0 L 139.5 82.0 Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 23",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 82.0 L 168.0 83.5 L 166.5 83.0 L 165.5 82.0 Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 23",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 83.0 L 160.5 88.0 L 164.5 83.0 Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 31",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 83.0 L 166.5 85.0 L 164.0 88.5 L 154.5 98.0 L 159.5 92.0 Q 163.2 90.0 161.5 88.0 Q 163.3 90.8 165.0 86.5 Q 162.3 84.8 166.5 83.0 Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 24",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 84.0 L 55.5 94.0 L 46.5 84.0 Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 24",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 85.0 L 151.5 102.0 L 167.5 85.0 Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 25",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 175.5 85.0 L 177.0 85.5 L 170.5 91.0 L 175.5 85.0 Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 32",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 86.0 L 135.5 88.0 L 136.5 86.0 Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 25",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 86.0 L 142.5 93.0 L 148.5 86.0 Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 26",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 122.5 88.0 L 126.0 88.5 L 122.5 89.0 L 122.5 88.0 Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 27",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 88.0 L 145.5 103.0 L 159.5 88.0 Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 33",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 88.0 L 163.5 102.0 L 165.0 99.5 L 165.0 97.5 L 166.5 95.0 L 166.0 96.5 L 166.5 98.0 L 172.0 92.5 Q 175.1 90.8 173.5 89.0 Q 175.0 91.5 176.5 88.0 Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 28",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 88.0 L 162.5 104.0 L 177.5 88.0 Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 34",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 89.0 L 135.0 91.5 L 134.0 91.5 L 134.5 89.0 Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 35",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 146.5 89.0 L 142.5 94.0 L 146.5 89.0 Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 29",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 90.0 Q 132.3 93.1 134.0 91.5 L 132.0 92.5 L 130.5 90.0 Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 36",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 188.5 90.0 L 187.5 92.0 L 188.5 90.0 Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 37",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 91.0 L 125.0 91.5 L 118.5 92.0 L 118.5 91.0 Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 38",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 91.0 L 132.5 94.0 L 130.5 91.0 Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 30",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 91.0 L 154.5 107.0 L 169.5 91.0 Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 31",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 123.5 92.0 L 126.0 92.5 L 123.5 93.0 L 123.5 92.0 Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 26",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 92.0 L 138.5 94.0 L 137.5 92.0 Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 39",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 92.0 L 145.5 104.0 L 156.5 92.0 Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 27",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 128.5 93.0 L 129.5 95.0 L 128.5 93.0 Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 40",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 93.0 L 137.5 95.0 L 136.5 93.0 Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 41",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 56.5 94.0 L 63.5 102.0 L 61.0 100.5 L 58.5 97.0 L 57.0 97.5 L 57.5 96.0 L 56.5 94.0 Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 28",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 94.0 L 136.5 96.0 L 135.5 94.0 Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 29",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 97.0 L 132.0 101.5 L 131.0 101.5 L 131.5 97.0 Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 30",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 134.5 97.0 L 135.0 102.5 L 134.0 102.5 L 134.5 97.0 Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 32",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 176.5 97.0 L 165.5 109.0 L 176.5 97.0 Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 42",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 98.0 L 162.5 100.0 L 161.5 103.0 Q 160.3 100.8 159.0 103.5 L 154.0 107.5 L 163.5 98.0 Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 43",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 100.0 L 173.5 102.0 L 174.5 100.0 Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 44",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 131.5 102.0 L 132.5 104.0 L 131.5 102.0 Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 45",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 102.0 L 141.5 104.0 L 140.5 102.0 Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 33",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 130.5 103.0 L 127.5 107.0 L 130.5 103.0 Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 46",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 103.0 L 171.5 105.0 L 170.5 107.0 L 170.5 105.0 L 171.5 103.0 Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 31",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 104.0 L 139.5 106.0 L 138.5 104.0 Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 47",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 105.0 L 145.0 106.5 L 142.5 107.0 L 141.5 105.0 Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 34",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 105.0 L 151.5 107.0 L 150.5 105.0 Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 32",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 132.5 106.0 L 130.5 109.0 L 132.5 106.0 Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 48",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 106.0 L 166.5 109.0 L 168.5 106.0 Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 35",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 118.5 107.0 L 117.5 109.0 L 118.5 107.0 Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 36",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 107.0 L 124.0 107.5 L 121.5 108.0 L 121.5 107.0 Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 33",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 107.0 L 149.5 110.0 L 147.5 107.0 Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 34",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 107.0 L 162.5 109.0 L 161.5 107.0 Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 35",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 109.0 L 96.0 109.5 L 91.5 110.0 L 91.5 109.0 Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 36",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 109.0 L 118.0 122.5 L 114.5 124.0 L 105.5 124.0 Q 103.0 123.0 104.0 118.5 L 105.0 118.5 L 105.5 123.0 L 117.0 122.5 L 117.5 109.0 Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 49",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 109.0 L 162.0 109.5 Q 159.9 112.8 159.5 109.0 Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 37",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 110.0 L 100.5 112.0 L 99.5 110.0 Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 50",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 110.0 L 125.0 110.5 L 121.0 111.5 L 121.0 120.5 L 122.0 124.5 L 120.0 123.5 L 120.5 110.0 Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 37",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 151.5 110.0 L 154.0 110.5 L 151.5 111.0 L 151.5 110.0 Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 38",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 159.5 110.0 L 160.5 112.0 L 159.5 110.0 Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 51",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 162.5 111.0 L 166.0 111.5 L 162.5 112.0 L 162.5 111.0 Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 38",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 111.0 L 169.0 119.5 L 168.0 119.5 L 168.5 111.0 Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 52",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 112.0 L 87.5 114.0 L 86.5 112.0 Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 39",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 112.0 L 95.0 112.5 L 92.5 113.0 L 92.5 112.0 Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 39",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 112.0 L 166.0 112.5 L 163.5 113.0 L 163.5 112.0 Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 40",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 113.0 L 84.5 115.0 L 85.5 113.0 Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 41",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 113.0 L 87.5 116.0 L 89.5 113.0 Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 4",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 113.0 Q 98.4 112.1 100.0 116.5 L 101.5 127.0 L 117.0 127.5 L 116.5 139.0 Q 111.8 137.8 110.5 140.0 L 104.0 144.5 Q 101.7 147.7 103.0 154.5 L 107.5 160.0 Q 110.8 162.8 117.0 162.5 L 116.5 174.0 L 102.5 174.0 Q 97.8 175.3 96.5 173.0 L 93.0 170.5 L 96.0 168.5 L 101.0 162.5 Q 104.0 161.5 103.0 156.5 L 99.0 150.5 L 100.0 146.5 L 96.5 142.0 L 89.0 141.5 L 87.5 139.0 L 81.5 138.0 L 78.5 140.0 Q 76.7 136.4 71.5 136.0 L 70.0 136.5 L 70.5 127.0 L 86.0 126.5 Q 84.6 117.1 89.5 114.0 L 91.5 113.0 Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 42",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 113.0 L 100.5 117.0 L 97.5 113.0 Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 40",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 113.0 L 103.5 115.0 L 102.5 113.0 Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 53",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 102.5 114.0 L 101.5 116.0 L 102.5 114.0 Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 43",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 119.0 L 83.0 122.5 L 79.5 124.0 L 70.5 124.0 L 69.0 120.5 L 70.0 120.5 L 70.5 123.0 L 82.0 122.5 L 82.5 119.0 Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 54",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 119.0 L 86.0 124.5 L 85.0 124.5 L 85.5 119.0 Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 44",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 119.0 L 102.5 126.0 L 112.5 126.0 Q 117.0 125.0 118.0 127.5 L 118.0 135.5 Q 118.8 139.3 116.5 140.0 L 112.0 139.5 L 117.0 138.5 L 116.5 127.0 L 106.5 127.0 Q 102.0 128.0 101.0 125.5 L 101.5 119.0 Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 41",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 123.0 L 131.5 123.0 Q 136.0 122.0 137.0 124.5 L 135.5 124.0 L 125.5 124.0 Q 120.5 125.0 121.5 123.0 Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 42",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 123.0 L 168.0 123.5 L 153.5 124.0 L 153.5 123.0 Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 55",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 124.0 L 133.5 127.0 L 120.0 126.5 L 129.5 126.0 Q 134.5 127.0 135.5 124.0 Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 56",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 124.0 L 153.0 125.5 L 152.5 132.0 L 152.0 125.5 L 153.5 124.0 Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 45",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 125.0 L 84.5 127.0 L 70.0 127.5 L 69.5 137.0 L 69.0 127.5 Q 70.0 125.0 74.5 126.0 L 81.5 126.0 L 85.5 125.0 Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 46",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 136.5 125.0 L 137.0 131.5 L 136.0 131.5 L 136.5 125.0 Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 57",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 126.0 L 166.0 126.5 L 157.5 127.0 L 157.5 126.0 Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 58",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 168.5 126.0 L 169.5 150.0 L 171.0 150.5 L 170.5 152.0 L 169.0 151.5 L 168.5 168.0 L 168.5 126.0 Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 47",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 127.0 L 121.0 140.5 L 120.0 140.5 L 120.5 127.0 Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 5",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 121.5 127.0 L 133.0 127.5 Q 131.9 133.6 134.5 136.0 L 139.5 141.0 L 145.5 142.0 Q 151.3 140.8 154.0 136.5 Q 156.8 133.3 156.5 127.0 L 160.5 128.0 L 168.0 128.5 L 167.0 159.5 Q 169.1 169.6 164.5 173.0 L 159.5 174.0 L 150.5 174.0 Q 148.6 169.9 141.5 171.0 Q 140.5 175.0 134.5 174.0 L 121.5 174.0 L 121.0 163.5 Q 122.0 159.0 119.5 158.0 Q 110.5 159.5 108.0 154.5 L 107.0 148.5 L 110.5 144.0 L 115.5 143.0 Q 120.0 144.0 121.0 141.5 L 121.5 127.0 Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 48",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 133.5 127.0 L 134.0 131.5 L 133.0 131.5 L 133.5 127.0 Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 49",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 127.0 L 156.0 130.5 L 155.0 130.5 L 155.5 127.0 Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 43",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 127.0 L 168.0 127.5 L 157.5 128.0 L 157.5 127.0 Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 50",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 133.0 L 155.0 134.5 L 153.0 135.5 L 154.5 133.0 Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 59",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 137.5 134.0 L 139.5 137.0 L 137.5 134.0 Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 44",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 138.5 134.0 L 139.5 136.0 L 138.5 134.0 Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 45",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 134.0 L 149.5 136.0 L 150.5 134.0 Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 60",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 135.0 L 150.0 136.5 L 151.0 138.5 L 149.0 137.5 L 150.5 135.0 Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 46",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 71.5 136.0 L 74.0 136.5 L 71.5 137.0 L 71.5 136.0 Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 51",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 135.5 136.0 L 138.5 140.0 L 135.5 136.0 Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 47",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 153.5 136.0 L 150.5 140.0 L 153.5 136.0 Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 61",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 139.0 L 75.5 142.0 Q 72.5 140.5 75.5 139.0 Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 48",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 139.0 L 80.0 139.5 Q 77.9 142.8 77.5 139.0 Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 62",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 139.0 L 83.0 141.5 L 81.0 140.5 L 81.5 139.0 Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 63",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 139.0 L 85.0 140.5 L 84.5 142.0 L 84.0 140.5 L 85.5 139.0 Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 49",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 87.5 139.0 L 88.5 141.0 L 87.5 139.0 Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 64",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 139.0 Q 120.5 140.5 117.5 142.0 L 117.5 139.0 Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 65",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 147.5 139.0 L 146.5 141.0 L 142.0 140.5 L 147.5 139.0 Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 52",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 70.5 140.0 L 47.5 164.0 L 70.5 140.0 Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 6",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 140.0 L 75.0 143.5 L 72.5 147.0 L 71.0 147.5 L 58.0 162.5 L 60.5 164.0 L 64.0 161.5 L 82.5 142.0 L 86.0 143.5 L 85.0 146.5 L 80.0 152.5 L 68.0 164.5 Q 69.8 168.8 71.5 166.0 L 73.0 165.5 L 74.5 163.0 L 76.0 162.5 L 91.5 146.0 Q 95.3 145.3 96.0 147.5 L 91.5 154.0 L 90.0 154.5 L 75.0 171.5 L 78.5 173.0 L 84.5 166.0 L 86.0 165.5 L 94.5 156.0 Q 98.3 155.3 99.0 157.5 L 93.5 165.0 L 80.0 178.5 L 75.0 183.5 L 73.0 187.5 L 76.5 188.0 L 91.5 174.0 Q 95.8 175.8 93.0 177.5 L 73.5 198.0 L 69.5 200.0 L 62.5 201.0 Q 57.8 199.8 56.5 202.0 L 52.0 206.5 L 50.5 209.0 Q 45.5 209.5 45.0 205.5 L 33.0 193.5 L 41.0 182.5 L 40.0 179.5 L 41.0 174.5 L 46.5 165.0 L 49.0 163.5 L 70.5 141.0 L 72.5 140.0 Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 50",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 140.0 L 74.5 142.0 L 73.5 140.0 Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 66",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 77.5 140.0 L 80.0 140.5 L 77.5 142.0 L 77.5 140.0 Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 67",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 108.5 141.0 L 107.5 143.0 L 108.5 141.0 Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 51",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 141.0 L 146.0 141.5 L 143.5 142.0 L 143.5 141.0 Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 53",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 81.5 142.0 L 60.5 164.0 L 58.0 162.5 L 59.5 163.0 L 81.5 142.0 Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 54",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 142.0 L 87.0 145.5 L 86.0 145.5 L 85.5 142.0 Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 52",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 142.0 L 98.5 145.0 L 96.5 142.0 Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 55",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 113.5 142.0 L 120.0 142.5 L 113.5 143.0 L 113.5 142.0 Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 68",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 143.0 L 97.5 145.0 L 96.5 143.0 Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 53",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 143.0 L 104.5 145.0 L 105.5 143.0 Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 56",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 110.5 143.0 L 109.5 145.0 L 110.5 143.0 Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 54",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 144.0 L 73.5 146.0 L 74.5 144.0 Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 69",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 75.5 144.0 L 78.0 144.5 L 75.0 146.5 L 73.0 146.5 L 75.5 144.0 Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 57",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 145.0 L 73.5 164.0 L 91.5 145.0 Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 58",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 145.0 L 95.5 147.0 L 94.5 145.0 Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 55",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 85.5 146.0 L 84.5 148.0 L 85.5 146.0 Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 70",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 86.5 146.0 L 86.5 148.0 L 85.5 150.0 L 85.5 148.0 L 86.5 146.0 Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 56",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 146.0 L 100.0 149.5 L 99.0 149.5 L 99.5 146.0 Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 71",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 146.0 L 173.5 148.0 L 175.0 147.5 L 173.0 148.5 L 171.0 147.5 L 170.5 149.0 L 170.5 146.0 Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 59",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 72.5 147.0 L 59.5 161.0 L 72.5 147.0 Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 72",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 96.5 147.0 L 97.0 149.5 L 95.0 150.5 L 96.5 147.0 Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 60",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 103.5 147.0 L 104.0 152.5 L 103.0 152.5 L 103.5 147.0 Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 57",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 147.0 L 172.0 168.5 L 171.0 168.5 L 171.5 147.0 Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 73",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 148.0 L 68.5 154.0 L 73.5 148.0 Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 61",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 106.5 148.0 L 107.0 152.5 L 106.0 152.5 L 106.5 148.0 Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    desc: "l 0 p 7",
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 148.0 L 187.5 163.0 Q 197.2 168.3 196.0 184.5 L 193.0 191.5 L 196.5 193.0 L 199.5 187.0 L 204.0 192.5 L 188.5 209.0 Q 181.3 207.3 178.5 201.0 Q 177.0 203.5 171.5 202.0 Q 161.0 199.5 155.5 192.0 L 142.0 179.5 Q 141.3 175.8 143.5 175.0 L 146.5 176.0 L 149.5 179.0 L 161.5 190.0 L 168.5 185.0 L 174.5 184.0 L 179.5 187.0 L 181.0 183.5 Q 177.9 178.6 168.5 180.0 L 161.5 185.0 L 155.5 178.0 Q 163.0 179.5 166.0 176.5 L 171.0 171.5 L 172.0 162.5 L 172.5 148.0 Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 58",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 95.5 149.0 L 93.5 152.0 L 95.5 149.0 Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 62",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 174.5 149.0 L 183.5 159.0 L 174.5 149.0 Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 63",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 82.5 150.0 L 69.5 164.0 L 82.5 150.0 Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 59",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 167.5 150.0 L 168.0 168.5 L 167.0 168.5 L 167.5 150.0 Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 74",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 151.0 L 82.5 153.0 L 83.5 151.0 Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 64",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 151.0 L 93.5 153.0 L 94.5 151.0 Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 60",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 151.0 L 101.5 155.0 L 98.5 151.0 Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 75",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 99.5 153.0 L 101.5 156.0 L 99.0 154.5 L 98.5 156.0 L 98.0 154.5 L 99.5 153.0 Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 76",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 153.0 L 171.0 159.5 L 170.0 159.5 L 170.5 153.0 Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 77",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 80.5 154.0 L 78.5 157.0 L 80.5 154.0 Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 65",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 154.0 L 76.5 170.0 L 91.5 154.0 Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 78",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 155.0 L 89.5 159.0 L 92.5 155.0 Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 66",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 94.5 155.0 L 83.5 167.0 L 94.5 155.0 Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 61",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 104.5 156.0 L 107.5 160.0 L 104.5 156.0 Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 79",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 105.5 156.0 L 108.0 156.5 L 107.5 158.0 L 108.5 160.0 L 105.5 156.0 Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 67",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 109.5 156.0 L 110.5 158.0 L 109.5 156.0 Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 80",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 64.5 157.0 L 63.5 159.0 L 64.5 157.0 Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 81",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 183.5 157.0 Q 185.3 160.1 187.0 158.5 Q 184.8 159.8 187.5 161.0 L 191.5 166.0 L 183.5 157.0 Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 68",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 114.5 158.0 L 120.0 158.5 L 114.5 159.0 L 114.5 158.0 Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 62",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 159.0 L 191.5 167.0 L 184.5 159.0 Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 82",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 61.5 160.0 L 60.5 162.0 L 61.5 160.0 Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 69",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 98.5 160.0 L 79.5 180.0 L 98.5 160.0 Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 70",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 101.5 161.0 L 94.5 169.0 L 101.5 161.0 Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 71",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 112.5 161.0 Q 117.0 160.0 118.0 162.5 L 116.5 162.0 Q 111.5 163.0 112.5 161.0 Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 63",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 120.5 161.0 L 121.0 173.5 L 120.0 173.5 L 120.5 161.0 Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 83",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 161.0 L 171.0 168.5 L 170.0 168.5 L 170.5 161.0 Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 64",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 48.5 163.0 L 47.5 165.0 L 48.5 163.0 Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 84",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 84.5 163.0 L 82.5 167.0 L 78.5 172.0 Q 75.0 170.0 79.5 168.0 Q 80.8 170.3 82.0 167.5 L 82.0 165.5 L 84.5 163.0 Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 85",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 163.0 L 118.0 174.5 L 117.0 174.5 L 117.5 163.0 Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 86",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 164.0 L 43.5 168.0 L 46.5 164.0 Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 87",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 193.5 165.0 L 194.5 167.0 L 193.5 165.0 Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 65",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 166.0 L 44.5 168.0 L 45.5 166.0 Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 66",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 83.5 167.0 L 78.5 173.0 L 83.5 167.0 Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 88",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 169.0 L 94.0 169.5 L 94.0 171.5 L 93.0 173.5 L 93.5 175.0 L 90.0 173.5 L 93.0 172.5 L 91.5 169.0 Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 72",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 171.0 L 146.0 171.5 L 142.5 172.0 L 142.5 171.0 Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 73",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 171.0 L 165.5 173.0 L 166.5 171.0 Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 89",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 172.0 L 88.5 174.0 L 86.0 177.5 L 75.5 188.0 L 88.5 172.0 Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 74",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 140.5 172.0 L 138.5 175.0 L 121.0 174.5 L 133.5 174.0 Q 139.3 175.3 140.5 172.0 Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 67",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 172.0 L 149.5 174.0 L 148.5 172.0 Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 75",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 169.5 172.0 L 166.5 176.0 L 169.5 172.0 Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 90",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 148.5 173.0 Q 151.5 174.5 148.5 176.0 L 148.5 173.0 Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 68",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 89.5 174.0 L 76.5 188.0 L 89.5 174.0 Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 69",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 92.5 174.0 L 93.5 176.0 L 92.5 174.0 Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 76",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 97.5 174.0 L 117.0 174.5 L 97.5 175.0 L 97.5 174.0 Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 91",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 174.0 L 141.5 176.0 L 142.5 174.0 Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 77",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 143.5 174.0 Q 148.5 173.5 149.0 177.5 L 145.5 175.0 Q 142.5 175.5 143.5 174.0 Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 78",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 150.5 174.0 L 162.0 174.5 L 150.5 175.0 L 150.5 174.0 Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 70",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 142.5 175.0 L 142.0 176.5 L 141.5 179.0 L 141.0 176.5 L 142.5 175.0 Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 71",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 40.5 176.0 L 41.0 178.5 L 40.0 178.5 L 40.5 176.0 Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 92",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 152.5 176.0 L 154.0 178.5 L 153.0 178.5 L 152.5 176.0 Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 79",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 176.0 L 197.0 183.5 L 196.0 183.5 L 196.5 176.0 Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 93",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 177.0 L 40.0 184.5 L 35.0 188.5 L 38.0 185.5 L 39.0 182.5 L 39.5 177.0 Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 94",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 177.0 L 154.0 180.5 L 156.0 181.5 L 155.5 184.0 L 149.5 177.0 Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 80",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 177.0 L 162.0 177.5 L 154.5 178.0 L 154.5 177.0 Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 72",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 149.5 178.0 L 154.5 184.0 L 149.5 178.0 Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 81",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 141.5 179.0 L 144.5 183.0 L 141.5 179.0 Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 82",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 155.5 179.0 L 160.5 185.0 L 155.5 179.0 Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 73",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 78.5 180.0 L 76.5 183.0 L 78.5 180.0 Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 83",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 91.5 180.0 L 89.5 183.0 L 91.5 180.0 Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 84",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 170.5 180.0 L 175.0 180.5 L 170.5 181.0 L 170.5 180.0 Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 85",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 181.0 L 178.5 183.0 L 177.5 181.0 Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 74",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 182.0 L 153.5 191.0 L 145.5 182.0 Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 75",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 164.5 182.0 L 163.5 184.0 L 164.5 182.0 Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 76",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 182.0 L 180.5 184.0 L 179.5 182.0 Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 77",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 88.5 183.0 L 75.5 197.0 L 88.5 183.0 Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 95",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 145.5 183.0 L 151.5 190.0 L 148.0 186.5 L 145.0 185.5 L 145.5 183.0 Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 96",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 183.0 L 158.5 185.0 L 157.5 183.0 Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 97",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 166.5 183.0 L 167.5 185.0 L 166.5 183.0 Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 86",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 171.5 183.0 L 174.0 183.5 L 171.5 184.0 L 171.5 183.0 Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 98",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 183.0 L 180.5 185.0 L 179.0 184.5 L 178.5 186.0 L 178.0 184.5 L 179.5 183.0 Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 78",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 184.0 L 73.5 186.0 L 74.5 184.0 Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 87",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 156.5 184.0 L 160.5 189.0 L 156.5 184.0 Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 79",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 39.5 185.0 L 35.5 190.0 L 39.5 185.0 Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 99",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 185.0 L 162.5 187.0 L 160.0 186.5 L 161.5 185.0 Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 100",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 185.0 L 164.5 187.0 L 165.5 185.0 Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 80",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 177.5 185.0 L 180.0 186.5 L 178.5 187.0 L 177.5 185.0 Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 88",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 73.5 186.0 L 74.5 188.0 L 73.5 186.0 Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 81",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 165.5 186.0 L 164.5 188.0 L 165.5 186.0 Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 89",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 199.5 186.0 L 203.5 191.0 Q 200.8 185.6 198.0 187.5 L 199.5 186.0 Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 90",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 163.5 187.0 L 162.5 189.0 L 163.5 187.0 Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 91",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 34.5 190.0 L 32.5 193.0 L 34.5 190.0 Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 92",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 154.5 191.0 L 160.5 198.0 L 154.5 191.0 Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 101",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 196.5 191.0 L 195.5 193.0 L 196.5 191.0 Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 82",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 197.5 191.0 L 196.5 193.0 L 197.5 191.0 Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 93",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 204.5 192.0 L 203.5 194.0 L 204.5 192.0 Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 94",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 33.5 194.0 L 47.5 209.0 L 33.5 194.0 Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 83",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 194.0 L 193.5 204.0 L 202.5 194.0 Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 102",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 202.5 195.0 L 201.5 199.0 Q 200.3 196.8 199.0 199.5 L 195.0 202.5 L 202.5 195.0 Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 95",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 74.5 197.0 L 73.5 199.0 L 74.5 197.0 Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 84",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 161.5 197.0 L 162.5 199.0 L 161.5 197.0 Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 103",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 37.5 201.0 L 38.5 203.0 L 37.5 201.0 Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    desc: "l 2 p 85",
    fill: "rgb(34,34,34)",
    stroke: "rgb(34,34,34)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 201.0 L 65.0 201.5 Q 54.8 200.3 52.5 207.0 L 57.5 201.0 Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 104",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 57.5 202.0 L 58.0 203.5 L 55.0 205.5 Q 57.3 206.8 54.5 208.0 Q 53.3 205.8 52.0 208.5 L 52.5 210.0 L 50.0 209.5 L 57.5 202.0 Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 105",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 59.5 202.0 L 63.0 202.5 L 59.5 203.0 L 59.5 202.0 Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 96",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 172.5 202.0 L 177.0 202.5 L 172.5 203.0 L 172.5 202.0 Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 97",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 179.5 202.0 L 183.5 207.0 L 179.5 202.0 Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    desc: "l 10 p 98",
    fill: "rgb(150,150,150)",
    stroke: "rgb(150,150,150)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 194.5 203.0 L 189.5 209.0 L 194.5 203.0 Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    desc: "l 4 p 106",
    fill: "rgb(239,239,239)",
    stroke: "rgb(239,239,239)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 184.5 207.0 L 186.5 210.0 L 184.5 207.0 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborating);
export default __webpack_public_path__ + "static/media/collaborating.f69036c11825bb83d4b61d4c1c207a4f.svg";
export { ForwardRef as ReactComponent };